import React, { Component } from 'react';
import { connect } from 'react-redux';

import globalClasses from '../../App.css';
import classes from './People.css';
import RoundButton from '../../components/UI/RoundButton/RoundButton';
import Icon from '../../components/UI/Icons/index';
import Footer from '../../components/UI/Footer/Footer';
import { bookingProcessPeopleAdd, bookingProcessPeopleRemove, bookingProcessSetStep } from '../../store/actions/bookingProcess';
import { BOOKING_STEPS } from '../../constants';
import Modal from '../../components/UI/Modal/Modal';
import Button from '../../components/UI/Button/Button';
import { FooterSpacer } from '../../components/FooterSpacer.js/FooterSpacer';

class People extends Component {

  state = {
    hasPopupBeenShowed: false,
    isModalOpen: false,
    isCreditCardImageLoaded: false,
  }

  componentDidMount() {
    this.props.bookingProcessSetStep();
  }

  continueHandler = () => {
    this.props.onNextStep();
    this.props.history.push({
      pathname: '/giorno-ora',
    });
  }

  backHandler = () => {
    this.props.onBackStep();
    this.props.history.goBack();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.people !== this.props.people && prevProps.people < 9 && this.props.people >= 9) {
      this.setState({ hasPopupBeenShowed: true, isModalOpen: true });
    }
  }

  render() {
    let disabled = this.props.people <= this.props.minPeople;
    let maxPeopleReached = this.props.people >= this.props.maxPeople;
    return (
      <React.Fragment>
        <Modal
          show={this.state.isModalOpen}
          modalClosed={() => this.setState({ isModalOpen: false, isCreditCardImageLoaded: false })}
          isFitToContent={true}
          dismissable={false}
          isFullScreen={true}
        >
          <div className={classes.ModalContentContainer}>
            <img
              src="/static/images/credit-card-example.png"
              alt=""
              className={classes.CreditCardImage}
              onLoad={() => this.setState({ isCreditCardImageLoaded: true })}
              style={{ display: this.state.isCreditCardImageLoaded ? 'block' : 'none' }}
            />
            {!this.state.isCreditCardImageLoaded &&
              <div className={classes.CreditCardLoaderContainer}>

              </div>
            }
            <p
              style={{ fontWeight: 300, fontSize: '18px', textAlign: 'center', flex: 1, display: 'flex', alignItems: 'center' }}
              dangerouslySetInnerHTML={{ __html: this.props.translations.label_warning_max_people }}
            ></p>
            <Button
              btnLabel={this.props.translations.label_ok}
              clicked={() => this.setState({ isModalOpen: false, isCreditCardImageLoaded: false })}
            />
          </div>
        </Modal>
        <div className={classes.Container} >
          <p className={globalClasses.PageTitle}>{this.props.translations.label_how_much}</p>
          <div className={classes.PeopleCounter}>
            <RoundButton name="minus" fill='white' clicked={this.props.onRemovePeople} disabledButton={disabled} />
            <div className={classes.PeopleVisual}>
              <Icon name="people" height="38" width="38" />
              <span className={classes.PeopleNumber}>{this.props.people}</span>
            </div>
            <RoundButton name="plus" fill='white' clicked={this.props.onAddPeople} disabledButton={maxPeopleReached} />
          </div>
          {maxPeopleReached && (<div className={classes.ModalContentContainer}>
            {this.props.popupDetails.secondaryTitle && <p className={classes.ModalTitle}>{this.props.popupDetails.secondaryTitle}</p>}
            {this.props.popupDetails.secondaryMessage && <p className={classes.ModalText}>{this.props.popupDetails.secondaryMessage}</p>}
            {this.props.popupDetails.secondaryButton && <Button btnLabel={<a className={classes.PhoneLink} href={`tel:${this.props.popupDetails.secondaryButton}`}>{this.props.popupDetails.secondaryButton}</a>} />}
          </div>)}
          <FooterSpacer />
          <Footer
            continueLbl={this.props.translations.label_continue}
            backClick={this.backHandler}
            nextClick={this.continueHandler}
          />
        </div>
      </React.Fragment>
    )
  }
};

const mapStateToProps = state => {
  const { bookingProcessReducer, storeReducer } = state;
  let store = storeReducer.stores[storeReducer.storeIdSelected] || {};
  return {
    people: bookingProcessReducer.numberOfPeople,
    maxPeople: store.maxOnlinePartySize,
    minPeople: store.minOnlinePartySize,
    translations: state.settingsReducer.translations,
    popupDetails: store.popupDetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onAddPeople: () => dispatch(bookingProcessPeopleAdd()),
    onRemovePeople: () => dispatch(bookingProcessPeopleRemove()),
    onNextStep: () => { },
    onBackStep: () => { },
    bookingProcessSetStep: () => dispatch(bookingProcessSetStep(BOOKING_STEPS.PEOPLE))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(People);


// WEBPACK FOOTER //
// ./src/containers/People/People.js